import {
  useFetchTableStateQuery,
  useRefreshTableStateMutation,
} from "../../../global/utils/redux/api/arrangementsApi.ts";
import { QueryStatus } from "@reduxjs/toolkit/query";
import { ReactNode } from "react";
import { useAppSelector } from "../../../global/utils/redux/store.tsx";
import { Button, ButtonProps } from "@mui/material";

export default function ArrangementReloadButton({
  children,
  sx = {},
}: {
  children: ReactNode;
  sx?: ButtonProps["sx"];
}) {
  const pincode = useAppSelector((state) => state.arrangements.ticket_pincode.pincode);
  const { isFetching } = useFetchTableStateQuery(pincode);
  const [refreshTableState, result] = useRefreshTableStateMutation();

  return (
    <Button
      variant="contained"
      size="small"
      onClick={() => refreshTableState()}
      loading={isFetching || result.status == QueryStatus.pending}
      sx={sx}
    >
      {children}
    </Button>
  );
}
